import * as colors from '../assets/colors.js';
import * as fonts from '../assets/fonts.js';
import media from '../assets/media.js';

var Theme = {
  colors: colors,
  fonts: fonts,
  media: media
};

export { Theme as default };
